const usingBase = Boolean(process.env.REACT_APP_API_BASE_URL);
const fallbackV4 = !usingBase && process.env.REACT_APP_API_V4;

if (fallbackV4) {
  // Single-run deprecation warning (module scope). Intentionally concise to avoid log spam.
  // Removal plan: once all environments define REACT_APP_API_BASE_URL, delete REACT_APP_API_V4 support.
  // Track: ODIN-TRAINING deprecate REACT_APP_API_V4.
  console.warn(
    '[deprecation] REACT_APP_API_V4 is deprecated; define REACT_APP_API_BASE_URL (ending with /) instead. Support will be removed after migration.'
  );
}

const rawBaseURL = usingBase ? `${process.env.REACT_APP_API_BASE_URL}v4/` : process.env.REACT_APP_API_V4;
const rawApiKey = process.env.REACT_APP_API_KEY;

// In the mobile WebView build, REACT_APP_API_BASE_URL and REACT_APP_API_KEY are
// intentionally not set at build time — the mobile app injects them at runtime via
// localStorage ClusterConfig. Skip the strict check to avoid crashing the WebView.
const isMobileBuild = process.env.REACT_APP_WEBVIEW_MODE_ENABLED === 'true';

if (!rawBaseURL && !isMobileBuild) {
  throw new Error('Missing REACT_APP_API_BASE_URL');
}

if (!rawApiKey && !isMobileBuild) {
  throw new Error('Missing REACT_APP_API_KEY');
}

export const apiBaseUrl: string = rawBaseURL ?? '';
export const apiKey: string = rawApiKey ?? '';
